import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { FaSearch, } from "react-icons/fa";

function PaymentInHistory({ clientData }) {

const navigate = useNavigate();
  const [expenseBill, setExpenseBill] = useState([])
  const [searchTerm, setSearchTerm] = useState('');
  const [invoiceSearch, setInvoiceSearch] = useState("");
  const [partySearchTerm, setPartySearchTerm] = useState("");


  const fetchSaleHistory = async () => {
    try {
      const res = await axios.get(`https://api.dectwinbilling.com/due-history/${clientData.id}`);

      const sortedData = [...res.data].sort((a, b) => b.invoiceNo - a.invoiceNo);

      setExpenseBill(sortedData);

      console.log(sortedData)

    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchSaleHistory();

  }, []);


  const filteredData = Array.isArray(expenseBill)
    ? expenseBill
      .filter((itm) =>
        Object.values(itm).some((val) =>
          String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
      )
    : [];

  return (
      <div className="container-fluid py-4">
      <div className="card shadow border-0 rounded-4">

  <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center flex-wrap">
  {/* Left Side */}
  <h4 className="mb-0 fw-bold">
    Payment In (Due) History
  </h4>


  <div
    className="d-flex align-items-center gap-2 flex-wrap justify-content-end"
  >
    <SearchBox
      placeholder="Customer Name / Number"
      value={partySearchTerm}
      onChange={(e) => setPartySearchTerm(e.target.value)}
    />

    <button
      className="btn btn-primary"
      onClick={() => navigate("/home")}
    >
      Back
    </button>
  </div>
</div>

        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-hover align-middle text-center">
              <thead >
                <tr>
                  <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Inv.No</th>
                  <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Customer Name</th>

                  <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Date </th>
                  <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Amount</th>
                  <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Pay Mode</th>
                   <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Type</th>
                
                </tr>
              </thead>

              <tbody>
                {filteredData.length === 0 ? (
                  <tr>
                    <td colSpan="8" className="text-center text-muted">
                      No Transaction Found
                    </td>
                  </tr>
                ) : (
                  filteredData.map((item, index) => (
                    <tr key={item.id}>
                      <td>{item.invoiceNo}</td>
                      <td>{item.name}</td>
                      <td>{item.date}</td>
                      <td>{item.amount}</td>
                      <td>{item.payment_method}</td>
                      <td>{item.b_type}</td>

                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PaymentInHistory


const SearchBox = ({ placeholder, value, onChange }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      border: "2px solid #ff5d94",
      borderRadius: "8px",
      overflow: "hidden",
      background: "#fff",
      flex: "1",
      minWidth: "220px",
    }}
  >
    <input
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      style={{
        border: "none",
        outline: "none",
        padding: "8px 12px",
        width: "100%",
        width: "100%",
        minWidth: "150px",
      }}
    />

    <div
      style={{
        padding: "0 10px",
        color: "#1d8cf8",
      }}
    >
      <FaSearch />
    </div>
  </div>
);